import { createElement } from "./dom_utils.js";
import {
  createDownloadButton,
  addDownloadButtonHoverBehavior,
} from "./download_button.js";

function formatTime(seconds) {
  if (!seconds || isNaN(seconds)) return "0:00";
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

function createAudioAttachmentDisplay(attachment) {
  const container = createElement("div", {
    style:
      "display: flex; align-items: center; gap: 6px; width: 100%; min-width: 0; max-width: 100%; overflow: hidden; box-sizing: border-box;",
  });

  let isPlaying = false;
  let currentTime = 0;
  let duration = 0;

  const playPauseButton = createElement("div", {
    style: `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      min-width: 32px;
      border-radius: 8px;
      cursor: pointer;
      flex-shrink: 0;
      background: rgba(0, 0, 0, 0.04);
      border: 1px solid rgba(0, 0, 0, 0.08);
    `,
  });

  const playIcon = createElement("img", {
    src: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/play_icon.svg",
    alt: "play",
    style: "width: 20px; height: 20px;",
  });

  playPauseButton.appendChild(playIcon);

  const controlsContainer = createElement("div", {
    style:
      "display: flex; align-items: center; gap: 6px; flex: 1; min-width: 0; max-width: 100%; overflow: hidden; box-sizing: border-box;",
  });

  const timeDisplay = createElement("span", {
    style: `
      font-size: 10px;
      color: rgba(0, 0, 0, 0.6);
      white-space: nowrap;
      font-family: "Plus Jakarta", sans-serif !important;
      flex-shrink: 0;
      min-width: fit-content;
    `,
  });
  timeDisplay.textContent = "0:00 / 0:00";

  const progressBar = createElement("input", {
    type: "range",
    min: "0",
    max: "100",
    value: "0",
    style: `
    flex: 1;
    width: 100%;
    min-width: 0;
    height: 6px;
    outline: none;
    border: none;
    opacity: 0.9;
    border-radius: 3px;
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.60) 0%,
      rgba(0, 0, 0, 0.60) 0%,
      #d3d3d3 0%,
      #d3d3d3 100%
    );
    overflow: hidden;
    box-sizing: border-box;
    `,
  });

  const audio = createElement("audio", {
    src: attachment.url,
  });

  audio.addEventListener("loadedmetadata", () => {
    duration = audio.duration;
    progressBar.max = duration;
    timeDisplay.textContent = `0:00 / ${formatTime(duration)}`;
  });

  audio.addEventListener("timeupdate", () => {
    currentTime = audio.currentTime;
    progressBar.value = currentTime;
    const progress = (currentTime / duration) * 100;
    progressBar.style.background = `linear-gradient(to right, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) ${progress}%, #d3d3d3 ${progress}%, #d3d3d3 100%)`;
    timeDisplay.textContent = `${formatTime(currentTime)} / ${formatTime(duration)}`;
  });

  audio.addEventListener("ended", () => {
    isPlaying = false;
    currentTime = 0;
    playPauseButton.innerHTML = "";
    const newPlayIcon = createElement("img", {
      src: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/play_icon.svg",
      alt: "play",
      style: "width: 20px; height: 20px;",
    });
    playPauseButton.appendChild(newPlayIcon);
  });

  playPauseButton.addEventListener("click", (e) => {
    e.stopPropagation();
    if (isPlaying) {
      audio.pause();
      playPauseButton.innerHTML = "";
      const newPlayIcon = createElement("img", {
        src: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/play_icon.svg",
        alt: "play",
        style: "width: 20px; height: 20px;",
      });
      playPauseButton.appendChild(newPlayIcon);
    } else {
      audio.play();
      playPauseButton.innerHTML = "";
      const pauseIcon = createElement("img", {
        src: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/pause_icon.svg",
        alt: "pause",
        style: "width: 20px; height: 20px;",
      });
      playPauseButton.appendChild(pauseIcon);
    }
    isPlaying = !isPlaying;
  });

  progressBar.addEventListener("input", (e) => {
    const newTime = parseFloat(e.target.value);
    audio.currentTime = newTime;
    currentTime = newTime;
  });

  const style = document.createElement("style");
  style.textContent = `
    input[type="range"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 0;
      height: 0;
      cursor: pointer;
    }
    input[type="range"]::-moz-range-thumb {
      width: 0;
      height: 0;
      cursor: pointer;
      border: none;
      background: transparent;
    }
  `;
  document.head.appendChild(style);

  controlsContainer.appendChild(timeDisplay);
  controlsContainer.appendChild(progressBar);

  const downloadButton = createDownloadButton({
    attachment,
    styles: {
      width: 28,
      height: 28,
      iconWidth: 16,
      iconHeight: 16,
      showByDefault: false,
    },
  });

  addDownloadButtonHoverBehavior(container, downloadButton);

  container.appendChild(playPauseButton);
  container.appendChild(controlsContainer);
  container.appendChild(downloadButton);
  container.appendChild(audio);

  return container;
}

export default createAudioAttachmentDisplay;